/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".preview-texto-legal[_ngcontent-%COMP%]{font-size:12px;line-height:1.5}\n/*# sourceMappingURL=texto-legal.component.css.map*/"];
export { styles as styles };
